import {HttpUtils} from "./common/HttpUtils";

export class ImageService {

    constructor(auth) {
        this._auth = auth;
        this._headers = HttpUtils.getHttpHeaders(auth, 'text/json');
        this._baseUrl = `${process.env.VUE_APP_API_URL}/v1/images`;
    }

    addImage(partNumber, file) {
        debugger;
        let url = `${this._baseUrl}/${partNumber}/add`;
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('file', file);
            HttpUtils.post(url, this._auth, formData)
                .then(() => { resolve() })
                .catch((ex) => {
                    console.error('[d835967] error adding image');
                    if (ex != null) {
                        console.log(ex);
                    }
                    reject(ex)
                });
        });
    }

    getImages(partNumber){

        let url = `${this._baseUrl}/${partNumber}`;

        return new Promise((resolve, reject) => {

            HttpUtils.get(url, this._auth).then(data => {

                resolve(data);

            }).catch(error => {

                console.error('[e603409] error retrieving images');
                if (error != null){
                    console.error(error);
                }

                reject(error);
            });

        });
    }

    updateOrder(partNumber, imagesOrder){
        let url = `${this._baseUrl}/${partNumber}/update-order`;

        if (!(imagesOrder instanceof Array)){
            throw new Error ('[e853304] Not an array');
        }

        return new Promise((resolve, reject) => {

            HttpUtils.put(url, this._auth, imagesOrder).then(response => {
                resolve();
            }).catch(error => {
                console.error('[e396461] Failure updating image order');
                if (error != null){
                    console.error(error);
                }

                reject(error);
            });

        });
    }

    deleteImage(partNumber, imageId){

        let url = `${this._baseUrl}/${partNumber}/${imageId}`;

        return new Promise( ((resolve, reject) => {

            HttpUtils.delete(url, this._auth).then(response => {
                resolve();
            }).catch(error =>{

                console.error('[e081292] Failure delete image');
                if (error != null){
                    console.error(error);
                }

                reject(error);
            })
        }));

    }

    missingImages()  {

        let url = `${process.env.VUE_APP_API_URL}/v1/reports/images/missing`;

        return new Promise( ((resolve, reject) => {

            HttpUtils.get(url, this._auth).then(data => {

                resolve(data);

            }).catch(error =>{
                console.error('[e582309] Failure generate missing images report');
                if (error != null){
                    console.error(error);
                }

                reject(error);
            });
        }));

    };

}

